export const Divider = () => {
  return <div className="my-1 h-px w-full bg-gray-200 dark:bg-gray-800" />
}
